/**
 * /admin/security · /account/security · /patient/account
 *
 * Container for all per-user security & privacy controls. The actual UI
 * lives in focused sub-components under ./security/ (iter 105 refactor):
 *   - TotpPanel.jsx       — TOTP setup / verify / disable flow
 *   - TransparencyPref.jsx — GDPR Article 12 monthly email opt-in
 *   - ConsentPrefs.jsx     — GDPR Article 7/9 granular consent
 *   - DangerZone.jsx       — data export + activate/deactivate + delete
 */
import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { useAuth } from '../../lib/auth';
import { t } from '../../lib/i18n';
import { TotpPanel } from './security/TotpPanel';
import { DangerZone } from './security/DangerZone';

export default function AdminSecurity() {
  const { locale } = useAuth();
  return (
    <div className="p-4 md:p-8 max-w-3xl">
      <div className="mb-6">
        <div className="text-xs uppercase tracking-[0.2em] text-accent font-medium mb-2 inline-flex items-center gap-1">
          <ShieldCheck className="w-3 h-3"/> {t(locale, 'account_privacy').toUpperCase()}
        </div>
        <h1 className="text-3xl md:text-4xl font-heading font-bold tracking-tight">{t(locale, 'account_privacy')}</h1>
        <p className="text-fg-muted text-sm mt-1">{t(locale, 'account_privacy_lede')}</p>
      </div>

      <TotpPanel/>

      {/* Iter 90+ — Self-serve GDPR controls (export, consents, deletion) */}
      <DangerZone locale={locale}/>
    </div>
  );
}
